import * as React from 'react';

export interface Props {
  value: string;
  id?: string;
  css?: string;
  onChange?: (value: string) => void;
  selectAttr?: object;
  // Adding a property to add external css class. 
  selectClassName?: string;
  disabled?: boolean;
}

class Select extends React.Component<Props, {}> {
  private dropdown: HTMLSelectElement;

  constructor(props: Props) {
    super(props);

    this.initDropdown = this.initDropdown.bind(this);
    this.onDropdownChange = this.onDropdownChange.bind(this);
  }

  componentDidUpdate() {
    this.initDropdown(this.dropdown);
  }

  public get selectElement(): HTMLSelectElement {
    return this.dropdown;
  }

  public get value() {
    return this.selectElement.value;
  }

  public render() {
    // Check if external css properties comes from parent
    let selectUserClass = this.props.selectClassName === null ? '' : this.props.selectClassName;
    return (
      <select
        disabled={this.props.disabled}
        id={this.props.id || ''}
        className={`${this.props.css || ''} ${selectUserClass} paddingTop4`}
        value={this.props.children ? this.props.value : ''}
        onChange={() => undefined}
        {...this.props.selectAttr}
        ref={this.initDropdown}
      >
        {this.props.children}
      </select>
    );
  }

  private initDropdown(element: HTMLSelectElement) {
    let self = this;
    this.dropdown = element;

    if (!element) {
      return;
    }

    // tslint:disable-next-line:no-string-literal
    $(element).formSelect();
    element.onchange = self.onDropdownChange.bind(this);
  }

  private onDropdownChange(e: React.ChangeEvent<HTMLSelectElement>) {
    let value = e.target.value;
    if (this.props.onChange) {
      this.props.onChange(value);
    }
  }
}

export default Select;



// WEBPACK FOOTER //
// ./src/Components/Select.tsx